// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-SchedActions-DeleteButton-DeleteButton-module__button--pP1yI {
  color: #c20034;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedulingControl/SchedulingTable/SchedTableToolbar/SchedActions/DeleteButton/DeleteButton.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".button {\n  color: #c20034;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-SchedActions-DeleteButton-DeleteButton-module__button--pP1yI`
};
export default ___CSS_LOADER_EXPORT___;
